import {
  IModalDialogOptions,
  ToolbarButtonDefinition,
  WIDGET_COMPONENT,
} from '../../types';
import { map, merge } from 'lodash';
import { BTN_CANCEL, BTN_CONTINUE } from '@text-content/button-templates';
import { WIDGET_FAMILY } from '@config/global-constants';
import { PdfTableHeader } from './pdf-table-header.type';
import { IPdfColumn } from './v2/pdf.type';
import { COMMON_GENERAL_MESSAGE_CLASS } from '@app/shared/constants/common-warn-grid-setting';
import { Observable, isObservable } from 'rxjs';
import { rx } from '@app/shared/rx';
import { asObservable } from '@app/shared/utils';
import { I18n } from '@app/i18n/strings-keys';

type PdfColumnHeader = Partial<PdfTableHeader> &
  Partial<Pick<IPdfColumn, 'path' | 'title' | 'required'>>;
interface PdfSelectColumnHeaderOption {
  showSelectAll?: boolean;
  tips?: string;
  titleObs?: Observable<string>;
  twoColumnLayout?: boolean;
  requiredNotDisabled?: boolean;
  resetButton?: ToolbarButtonDefinition;
  additionalModalOptions?: IModalDialogOptions;
}

const selectPdfTableHeadersModal = (
  headerColumns: PdfColumnHeader[] | Observable<PdfColumnHeader[]>,
  defaultValuesObs: Observable<string[]>,
  options: PdfSelectColumnHeaderOption = {},
): IModalDialogOptions => {
  const {
    showSelectAll = true,
    tips = '',
    twoColumnLayout = false,
    requiredNotDisabled = false,
    titleObs,
    resetButton,
    additionalModalOptions = {},
  } = options;
  const columns = isObservable(headerColumns)
    ? headerColumns
    : asObservable(headerColumns);

  return merge(
    {},
    {
      title: I18n.Common.SelectColumnsToExport,
      validation: true,
      modalClass: `${twoColumnLayout ? 'two-column modal-lg' : 'modal-md'} hidden-header-checkbox`,
      buttons: [BTN_CONTINUE, resetButton, BTN_CANCEL],
      value: {
        tips,
        selected_columns: [],
      },
      schema: {
        type: 'object',
        properties: {
          tips: {
            type: 'string',
          },
          selected_columns: {
            type: 'array',
          },
        },
      },
      formRules: {
        fields: {
          tips: {
            widget: WIDGET_COMPONENT.label,
            widgetFamily: WIDGET_FAMILY.LEGACY,
            title: tips,
            widgetData: {
              itemClass: COMMON_GENERAL_MESSAGE_CLASS,
            },
            show: !!tips,
          },
          // use the config can not update the selected_columns's field name because use in pop-column-selector
          selected_columns: {
            titleObs,
            widget: WIDGET_COMPONENT.checkbox_group,
            widgetFamily: WIDGET_FAMILY.XUX,
            description: I18n.InfoMessages.TheDisabledFieldsAlwaysPrinted,
            widgetData: {
              showSelectAll,
              twoColumnLayout,
              multiselect: true,
            },
            selectOptions: columns.pipe(
              rx.map((items: PdfColumnHeader[]) => {
                return map(items, (item: PdfColumnHeader) => ({
                  text: item?.text || item?.title,
                  value: item?.text || item?.title || item?.path,
                  ...(!requiredNotDisabled
                    ? {
                        disabled: item.required || item.disabled,
                      }
                    : {
                        disabled: item.disabled,
                      }),
                }));
              }),
            ),
            defaultValue: defaultValuesObs,
          },
        },
      },
    },
    additionalModalOptions,
  );
};

export const pdfModalDefinition = {
  selectPdfTableHeadersModal,
};
